import { render } from "./IdentifySelect.vue?vue&type=template&id=5c218380&scoped=true"
import script from "./IdentifySelect.vue?vue&type=script&lang=js"
export * from "./IdentifySelect.vue?vue&type=script&lang=js"

import "./IdentifySelect.vue?vue&type=style&index=0&id=5c218380&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c218380"]])

export default __exports__